import getModalActions from '../../../../shared/modals/getModalActions';
import { MODAL_NAMES } from '../constants';

export const {
  showAction: showDeleteScenarioObligationModal,
  hideAction: hideDeleteScenarioObligationModal,
} = getModalActions(MODAL_NAMES.DeleteScenarioObligationModal);
